import $ from 'jquery';
import ajax from '../../utils/ajax';

const { FieldValidationProvider } = window.tnew.lib;


function makeContributionTypesMap(contributionTypes = []) {
  const map = new Map();

  contributionTypes.forEach((contributionType) => {
    const key = contributionType.contributionProduct.id.toString();

    map.set(key, contributionType);
  });

  return map;
}


class ContributionProvider {
  contributionType = null;
  addedContributionAmount = 0;

  constructor(contributionTypes, addedContributionId, addedContributionAmount) {
    this.contributionTypes = makeContributionTypesMap(contributionTypes);
    this.validationProvider = FieldValidationProvider.createStandardProvider('tn-contribution-form');
    this.addedContributionId = addedContributionId;
    this.$addContributionAmmount = $('#AddContribution_Amount');

    if (addedContributionAmount) {
      this.addedContributionAmount = addedContributionAmount;
    }
  }

  listen() {
    $(document).on('change', '#AddContribution_ContributionTypeId', () => {
      this.validationProvider.resetFieldMessages('AddContribution.Amount');
      this.loadContribution();
      this.loadForms();
    });

    this.loadContribution();
  }

  loadContribution() {
    const contributionTypeId = $('#AddContribution_ContributionTypeId').val();

    if (contributionTypeId === '') {
      return;
    }

    this.contributionType = this.contributionTypes.get(contributionTypeId);

    if (this.contributionType == null) {
      return;
    }

    const contributionComponent = this.contributionType.contributionFormComponent;

    if (!contributionComponent.contributionTypeText) {
      contributionComponent.contributionTypeText = '';
    }

    $('.tn-contribution-type-text').html(contributionComponent.contributionTypeText);

    let amount = '';

    if (contributionComponent.isSuggestedAmountEditable) {
      this.$addContributionAmmount.removeAttr('readonly');

      if (this.addedContributionId === contributionTypeId) {
        amount = this.addedContributionAmount;
        this.updateAmountInput(amount);
        return;
      }
    } else {
      this.$addContributionAmmount.prop('readonly', 'true');
    }

    if (contributionComponent.suggestedAmount > 0) {
      amount = contributionComponent.suggestedAmountDisplay;
    }

    this.updateAmountInput(amount);
  }

  updateAmountInput(value) {
    this.$addContributionAmmount.val(value);
  }

  async loadForms() {
    $('.tn-contribution-type-form-container').hide(100);
    const contributionComponent = this.contributionType.contributionFormComponent;

    let keys = contributionComponent.formTemplateKeys;

    if (keys && keys.constructor === Array && keys.length > 0) {
      $('.tn-form-loader').show(100);

      keys = keys.join();

      const response = await ajax.get('/api/forms/html', { keys });

      if (response) {
        $('.tn-form-loader').hide();
        $('.tn-contribution-type-form-container').html(response).show(100);
      } else {
        $('.tn-form-loader').hide();
      }
    }
  }
}

export default ContributionProvider;



// WEBPACK FOOTER //
// ./V7/products/contribution/ContributionProvider.js